// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zLightBlue":"rgb(75, 137, 220)","tag":"_2L9L","xs":"_16T7"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Tag/Tag.scss
// module id = qqJj
// module chunks = 0